<template>
  <div id="video-page" v-if="pageOnDisplay !== null">
    <div id="video">
      <!-- <iframe
        width="1080"
        height="1920"
        :src="`https://www.youtube.com/embed/${videos[pageOnDisplay].id}?controls=0&autoplay=1&mute=1&rel=0&loop=0`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
        allowfullscreen>
      </iframe> -->
      <iframe
        width="1080"
        height="1920"
        :src="`https://player.vimeo.com/video/${videos[pageOnDisplay].id}?autoplay=1&loop=1&muted=1&controls=0`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
        allowfullscreen>
      </iframe>
    </div>

    <div class="dock">
      <div class="dock-banner">
        <div
          class="dock-item"
          @click="changePage('previous')">
          <app-icon
            name="previous"
            size="small"
            :color="videos.length > 1 ? '#fff' : '#1b1b1b'"/>
        </div>
        <div class="dock-item" @click='resetTimer()'>
          <Waiter
            :relativeProgress='timerRelativeProgress'
            icon="replay"
            color="rgba(255,255,255, 1)" />
        </div>
        <div
          class="dock-item"
          @click="changePage('next')">
          <app-icon
            name="next"
            size="small"
            :color="videos.length > 1 ? '#fff' : '#1b1b1b'"/>
        </div>

        <div class="dock-button">
          <app-icon
            @click="stopConsultation()"
            name="dockHomeButton"
            size="inter"
            color="black"/>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  #video-page
    background: rgba(0,0,0,.75)
    bottom: 0
    display: flex
    flex-direction: column
    left: 0
    position: absolute
    right: 0
    top: 0
    #video
      align-items: center
      display: flex
      height: 100%
      justify-content: center
      pointer-events: none
      width: 100%
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';
import Waiter from '@/components/appModules/Waiter.vue';

export default {
  name: 'VideoPage',

  components: {
    AppIcon,
    Waiter,
  },

  data() {
    return {
      pageOnDisplay: null,
      TIMER_DURATION: 90000,
      timerStartTime: null,
      timerRelativeProgress: 0,
      timerAnimation: null,
      videos: [
        {
          id: '235486743',
        },
      ],
    };
  },

  activated() {
    this.pageOnDisplay = 0;
    this.timerAnimation = requestAnimationFrame(this.animateTimer);
  },

  deactivated() {
   cancelAnimationFrame(this.timerAnimation);
    this.timerAnimation = null;
    this.timerStartTime = null;
    this.timerRelativeProgress = 0;
    this.pageOnDisplay = null;
  },

  methods: {
    changePage(type) {
      const nextPage = this.pageOnDisplay + 1 >= this.videos.length
        ? 0
        : this.pageOnDisplay + 1;
      const previousPage = this.pageOnDisplay - 1
        ? this.videos.length - 1
        : this.pageOnDisplay - 1;
      this.pageOnDisplay = type === 'previous' ? previousPage : nextPage;
      this.resetTimer();
    },

    stopConsultation() {
      this.$router.push({ name: 'home' });
    },

    animateTimer(timestamp) {
      if (!this.timerStartTime) this.timerStartTime = timestamp;

      const runTime = timestamp - this.timerStartTime;
      this.timerRelativeProgress = runTime / this.TIMER_DURATION;

      if (runTime < this.TIMER_DURATION) {
        this.timerAnimation = requestAnimationFrame(this.animateTimer);
      } else {
        cancelAnimationFrame(this.timerAnimation);
        this.timerAnimation = null;
        this.timerStartTime = null;
        this.timerRelativeProgress = 0;
        this.stopConsultation();
      }
    },

    resetTimer() {
      cancelAnimationFrame(this.timerAnimation);
      this.timerAnimation = null;
      this.timerStartTime = null;
      this.timerRelativeProgress = 0;
      this.timerAnimation = requestAnimationFrame(this.animateTimer);
    },
  },
};
</script>